import { useNavigate } from 'react-router-dom'

const H = ({ style, ...p }: React.HTMLAttributes<HTMLElement>) => (
  <span style={{ fontFamily: "'Space Grotesk', sans-serif", ...style }} {...p} />
)

const FREE_FEATURES = [
  'Miễn phí mãi mãi — không hết hạn',
  'Kiểm tra đầu vào VSTEP',
  'Lộ trình học cá nhân hoá',
  '1 bài Writing AI/ngày',
  '1 bài Speaking AI/ngày',
  '10 câu Drill AI/ngày',
  '50 từ vựng SRS',
  'Dashboard tiến độ cơ bản',
  'Thử thách cộng đồng tuần',
]

const PRO_FEATURES = [
  'Phiên học không giới hạn',
  'AI Writing Coach nâng cao',
  'AI Speaking Coach + phát âm',
  'Từ vựng không giới hạn',
  'Mock Test 4 kỹ năng đầy đủ',
  'Báo cáo chi tiết + AI tutor',
  'Ưu tiên ghép Study Buddy',
  'Hỗ trợ 24/7',
]

/** Subscription Pricing Page */
export default function PricingPage() {
  const navigate = useNavigate()

  return (
    <div style={{ minHeight: '100vh', background: '#f6f6ff', fontFamily: "'Manrope', sans-serif", color: '#272e42' }}>
      {/* Nav */}
      <nav style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1.25rem 2rem', background: 'rgba(255,255,255,0.65)', backdropFilter: 'blur(24px)', position: 'sticky', top: 0, zIndex: 10, boxShadow: '0 20px 40px rgba(0,75,226,0.06)' }}>
        <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <div style={{ width: '2.25rem', height: '2.25rem', borderRadius: '0.75rem', background: 'linear-gradient(135deg,#004be2,#809bff)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span className="material-symbols-outlined" style={{ color: 'white', fontSize: '1.25rem', fontVariationSettings: "'FILL' 1" }}>bolt</span>
          </div>
          <H style={{ fontWeight: 800, fontSize: '1.25rem', letterSpacing: '-0.03em', color: '#004be2' }}>EngHustle</H>
        </button>
        <button onClick={() => navigate('/dashboard')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#535b71', fontWeight: 600, fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
          <span className="material-symbols-outlined" style={{ fontSize: '1rem' }}>arrow_back</span>
          Quay lại
        </button>
      </nav>

      <main style={{ maxWidth: '60rem', margin: '0 auto', padding: '4rem 2rem' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '0.375rem 1rem', borderRadius: '9999px', background: 'rgba(142,0,213,0.08)', marginBottom: '1.25rem' }}>
            <span className="material-symbols-outlined" style={{ color: '#8e00d5', fontSize: '1rem', fontVariationSettings: "'FILL' 1" }}>diamond</span>
            <span style={{ fontSize: '0.6875rem', fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#8e00d5' }}>Gói dịch vụ</span>
          </div>
          <H style={{ display: 'block', fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 900, letterSpacing: '-0.03em', marginBottom: '0.75rem' }}>
            Chọn gói phù hợp<br />với hành trình của bạn
          </H>
          <p style={{ color: '#535b71', fontSize: '1.0625rem', lineHeight: 1.6 }}>
            Bắt đầu miễn phí mãi mãi. Nâng cấp Pro để bỏ giới hạn số bài AI mỗi ngày.
          </p>
        </div>

        {/* Pricing cards */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', marginBottom: '3rem' }}>
          {/* Free plan */}
          <div style={{ background: 'white', borderRadius: '2rem', padding: '2.5rem', boxShadow: '0 10px 30px rgba(0,0,0,0.04)' }}>
            <span style={{ display: 'block', fontSize: '0.6875rem', fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#535b71', marginBottom: '0.75rem' }}>Miễn phí</span>
            <H style={{ display: 'block', fontSize: '3.5rem', fontWeight: 900, color: '#272e42', lineHeight: 1, marginBottom: '0.375rem' }}>
              $0
            </H>
            <span style={{ color: '#535b71', fontSize: '0.875rem', display: 'block', marginBottom: '2rem' }}>Mãi mãi · Không hết hạn</span>

            <button
              onClick={() => navigate('/dashboard')}
              style={{ width: '100%', padding: '1rem', borderRadius: '9999px', border: '2px solid #d1dcff', background: 'transparent', color: '#272e42', fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, cursor: 'pointer', marginBottom: '2rem' }}
            >
              Bắt đầu miễn phí
            </button>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.875rem' }}>
              {FREE_FEATURES.map(f => (
                <div key={f} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <span className="material-symbols-outlined" style={{ color: '#004be2', fontSize: '1.125rem', fontVariationSettings: "'FILL' 1" }}>check_circle</span>
                  <span style={{ fontSize: '0.9375rem', color: '#272e42' }}>{f}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Pro plan */}
          <div style={{ background: 'linear-gradient(135deg, #004be2, #809bff)', borderRadius: '2rem', padding: '2.5rem', position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', bottom: '-3rem', right: '-3rem', width: '14rem', height: '14rem', background: 'rgba(142,0,213,0.3)', borderRadius: '50%', filter: 'blur(40px)' }} />

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
              <span style={{ fontSize: '0.6875rem', fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.75)' }}>Pro</span>
              <span style={{ padding: '0.25rem 0.75rem', borderRadius: '9999px', background: 'rgba(255,255,255,0.2)', fontSize: '0.625rem', fontWeight: 800, color: 'white', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Phổ biến nhất</span>
            </div>
            <H style={{ display: 'block', fontSize: '3.5rem', fontWeight: 900, color: 'white', lineHeight: 1, marginBottom: '0.375rem', position: 'relative' }}>
              150.000đ
            </H>
            <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.875rem', display: 'block', marginBottom: '2rem' }}>/tháng</span>

            <button
              disabled
              style={{ width: '100%', padding: '1rem', borderRadius: '9999px', border: 'none', background: 'rgba(255,255,255,0.2)', color: 'rgba(255,255,255,0.5)', fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, cursor: 'not-allowed', marginBottom: '2rem', fontSize: '0.9375rem', position: 'relative' }}
            >
              Sắp ra mắt — Coming Soon
            </button>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.875rem', position: 'relative' }}>
              {PRO_FEATURES.map(f => (
                <div key={f} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <span className="material-symbols-outlined" style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.125rem', fontVariationSettings: "'FILL' 1" }}>check_circle</span>
                  <span style={{ fontSize: '0.9375rem', color: 'white' }}>{f}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* FAQ teaser */}
        <div style={{ textAlign: 'center', color: '#535b71', fontSize: '0.9375rem' }}>
          Có câu hỏi? {' '}
          <button onClick={() => navigate('/help')} style={{ background: 'none', border: 'none', color: '#004be2', fontWeight: 700, cursor: 'pointer', textDecoration: 'underline' }}>
            Xem trung tâm hỗ trợ →
          </button>
        </div>
      </main>
    </div>
  )
}
